import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Flame, Clock, ShieldCheck, Activity } from 'lucide-react';
import { Button, scrollToPricing, goToCheckout, FadeIn } from './Shared';
export const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-md py-3' : 'bg-transparent py-5'}`} data-id="element-100">
      <div className="max-w-6xl mx-auto px-6 flex justify-between items-center" data-id="element-101">
        <div className="font-playfair font-bold text-xl md:text-2xl text-terracotta flex items-center gap-2" data-id="element-102">
          <Flame className="w-6 h-6" data-id="element-103" />
          <span data-id="element-104">BOCHORNOS A RAYA</span>
        </div>
        <button onClick={goToCheckout} className="bg-terracotta text-white px-5 py-2 md:px-6 md:py-2.5 rounded-full font-medium text-sm md:text-base hover:bg-terracotta-dark transition-colors shadow-md" data-id="element-105">
          Comprar Ahora
        </button>
      </div>
    </header>;
};
export const Hero = () => {
  return <section className="relative pt-32 pb-20 md:pt-48 md:pb-32 overflow-hidden" data-id="element-106">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-107">
        <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-terracotta/5 blur-3xl" data-id="element-108"></div>
        <div className="absolute top-[40%] -left-[10%] w-[50%] h-[50%] rounded-full bg-gold/10 blur-3xl" data-id="element-109"></div>
      </div>

      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-110">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-111">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white border border-terracotta/20 text-terracotta text-sm font-medium mb-8 shadow-sm" data-id="element-112">
            <span className="w-2 h-2 rounded-full bg-terracotta animate-pulse" data-id="element-113"></span>
            Preparado exclusivamente para la mujer latina
          </div>

          <h1 className="text-5xl md:text-7xl font-bold text-brown leading-tight mb-6" data-id="element-114">
            BOCHORNOS <span className="text-terracotta italic" data-id="element-115">A RAYA</span>
          </h1>

          <h2 className="text-2xl md:text-3xl font-playfair text-brown-light mb-6 leading-snug" data-id="element-116">
            El Protocolo de 14 Días para apagar el incendio interno y recuperar
            tu vida.
          </h2>

          <p className="text-lg md:text-xl text-brown/80 mb-10 max-w-2xl mx-auto font-light" data-id="element-117">
            Deja de sobrevivir a la menopausia y empieza a dominarla. Un sistema
            diseñado para la mujer real que no tiene tiempo que perder.
          </p>

          <Button onClick={scrollToPricing} className="w-full md:w-auto md:px-12 md:py-5 text-xl" data-id="element-118">
            Quiero Apagar el Incendio Hoy
          </Button>
          <p className="mt-4 text-sm text-brown/60 flex items-center justify-center gap-2" data-id="element-119">
            <ShieldCheck className="w-4 h-4" data-id="element-120" /> Acceso inmediato al PDF
          </p>
        </motion.div>
      </div>
    </section>;
};
export const TrustBar = () => {
  const stats = [{
    icon: Clock,
    text: 'Protocolo de 14 Días'
  }, {
    icon: Activity,
    text: 'Resultados en 48-72 hrs'
  }, {
    icon: Flame,
    text: 'Basado en 6 Anclas Biológicas'
  }];
  return <div className="bg-white py-8 border-y border-terracotta/10" data-id="element-121">
      <div className="max-w-5xl mx-auto px-6" data-id="element-122">
        <div className="flex flex-col md:flex-row justify-center items-center gap-8 md:gap-16" data-id="element-123">
          {stats.map((stat, idx) => <div key={idx} className="flex items-center gap-3 text-brown-light font-medium" data-id="element-124">
              <div className="w-10 h-10 rounded-full bg-cream flex items-center justify-center text-terracotta" data-id="element-125">
                <stat.icon className="w-5 h-5" data-id="element-126" />
              </div>
              <span data-id="element-127">{stat.text}</span>
            </div>)}
        </div>
      </div>
    </div>;
};